export default __webpack_public_path__ + "static/media/2028.aaa52ca2.png";